import { type Reducer } from 'redux';
import {
    CREDIT_APP_SEARCH_OPEN_SLIDEOUT,
    CREDIT_APP_SEARCH_CLOSE_SLIDEOUT,
    CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER,
    CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER
} from '../actionTypes/creditAppSearchActionTypes';
import { OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';

export interface CreditAppSearchState {
    slideOutOpen: boolean;
    showSaveReminder: boolean;
}

export type CreditAppSearchReducer = Reducer<CreditAppSearchState>;

const initialState: CreditAppSearchState = {
    slideOutOpen: false,
    showSaveReminder: false
};

export const reducer = (state = initialState, action: any): CreditAppSearchState => {
    switch (action.type) {
        case CREDIT_APP_SEARCH_OPEN_SLIDEOUT: {
            return {
                ...state,
                slideOutOpen: true
            };
        }

        case CREDIT_APP_SEARCH_CLOSE_SLIDEOUT: {
            return {
                ...state,
                slideOutOpen: false
            };
        }

        case CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER: {
            return {
                ...state,
                showSaveReminder: true
            };
        }

        case CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER:
        case OFFER_SAVE_SUCCESS: {
            return {
                ...state,
                showSaveReminder: false
            };
        }

        default:
            return state;
    }
};
